import { callApiToServer } from '../callApi';

export async function editDistributor(
    authtoken,
    distributorObject
) {
    try {
        let header = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            "authorization": "Berear " + authtoken
        };

        let body = JSON.stringify(distributorObject);

        let endUrl = "v1/auth/edit-distributor";
        console.log("endUrl printed here", endUrl);

        let responseData = await callApiToServer(body, header, "POST", endUrl);

        return responseData;

    } catch (err) {
        throw err;
    }
}
